import theme from '../../../lib/theme';
import { ColumnBlockProps } from './ColumnBlock';
import { getBlockSpacing } from '../behaviour';

const { layouts, scale, media, colors } = theme;

const flexGap = '1rem';

export default ({ block: { columns } }: ColumnBlockProps) => ({
  container: {},

  columnsContainer: {
    flexWrap: 'wrap',
    gap: `${flexGap}`,
    marginTop: '0 !important',
  },

  columnItem: {
    flexBasis: `calc(${100 / columns.length}% - ${flexGap})`,
    maxWidth: `calc(${100 / columns.length}% - ${flexGap})`,
  },

  title: {
    margin: `0 !important`,
    padding: `0 !important`,
    fontWeight: '700',
    color: colors.tas.primary,
  },

  subtitle: {
    margin: `0 !important`,
    padding: `0 !important`,
    fontWeight: '700',
    color: colors.tas.primary,
  },
});
